import useOnclickOutside from 'react-cool-onclickoutside';

import Button from '../../../components/atoms/button';
import Card from '../../organisms/Card';

import './Modal.scss';

export interface ConfirmModalProps {
  promptText?: string;
  onConfirm?: () => void;
  onClose?: () => void;
}

function ConfirmModal({ promptText, onConfirm, onClose }: ConfirmModalProps) {
  const ref = useOnclickOutside(
    () => {
      onClose?.();
    },
    { eventTypes: ['mouseup'] }
  );
  return (
    <Card className="modal p-8" innerRef={ref}>
      <p className="mb-8">{promptText ? promptText : 'Are you sure?'}</p>
      <div className="flex gap-8">
        <Button onClick={onConfirm}>Confirm</Button>
        <Button visualType={'secondary'} onClick={onClose}>
          Cancel
        </Button>
      </div>
    </Card>
  );
}

export default ConfirmModal;
